module.exports = __webpack_public_path__ + "img/hourglass-dent-red.a10d280a.svg";